import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import GatewayHomePage from './pages/GatewayHomePage';
import WarmerPage from './pages/WarmerPage';
import BuyPage from './pages/BuyPage';
import CameraPage from './pages/CameraPage';
import StatusPage from './pages/StatusPage';
import SuccessPage from './pages/SuccessPage';
import FAQPage from './pages/FAQPage';
import RenewPage from './pages/RenewPage';
import AmazonPage from './pages/AmazonPage';
import EbayPage from './pages/EbayPage';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import InstallWindows from './pages/docs/InstallWindows';
import InstallMacOS from './pages/docs/InstallMacOS';
import InstallLinux from './pages/docs/InstallLinux';
import DocsPage from './pages/docs/DocsPage';
import Troubleshooting from './pages/docs/Troubleshooting';
import HowItWorks from './pages/docs/HowItWorks';
import GettingStarted from './pages/docs/GettingStarted';
import ContactSupport from './pages/docs/ContactSupport';
import SupportedWebsites from './pages/docs/SupportedWebsites';
import Changelog from './pages/Changelog';
import ReferralPage from './pages/ReferralPage';
import ReferralWarmerPage from './pages/ReferralWarmerPage';
import ReferralCameraPage from './pages/ReferralCameraPage';
import ReferrerLoginPage from './pages/ReferrerLoginPage';
import ReferrerPanelPage from './pages/ReferrerPanelPage';
import UsersPage from './pages/admin/UsersPage';
import AdminsPage from './pages/admin/AdminsPage';
import AmazonUsersPage from './pages/admin/AmazonUsersPage';
import ReferrersPage from './pages/admin/ReferrersPage';
import FeedbackPage from './pages/admin/FeedbackPage';
import PaymentsPage from './pages/admin/PaymentsPage';
import PayoutsPage from './pages/admin/PayoutsPage';
import DashboardPage from './pages/admin/DashboardPage';
import HWIDPage from './pages/admin/HWIDPage';
import CameraUsersPage from './pages/admin/CameraUsersPage';
import TelegramNotification from './components/TelegramNotification';
import './index.css';

const PrivateRoute = ({ children }) => {
  const adminToken = localStorage.getItem('adminToken');
  return adminToken ? children : <Navigate to="/admin/login" />;
};

function App() {
  return (
    <Router>
      {/* <TelegramNotification /> */}
      <Routes>
        <Route path="/" element={<GatewayHomePage />} />
        <Route path="/warmer" element={<WarmerPage />} />
        <Route path="/buy" element={<BuyPage />} />
        <Route path="/camera" element={<CameraPage />} />
        <Route path="/status" element={<StatusPage />} />
        <Route path="/status/:paymentId" element={<StatusPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/renew" element={<RenewPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route 
          path="/admin" 
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />
        <Route 
          path="/admin/users" 
          element={
            <PrivateRoute>
              <UsersPage />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/admin/admins" 
          element={
            <PrivateRoute>
              <AdminsPage />
            </PrivateRoute>
          }
        />
        <Route 
          path="/admin/amazon" 
          element={
            <PrivateRoute>
              <AmazonUsersPage />
            </PrivateRoute>
          }
        />
        <Route 
          path="/admin/referrers" 
          element={
            <PrivateRoute>
              <ReferrersPage />
            </PrivateRoute>
          }
        />
        <Route 
          path="/admin/feedback" 
          element={
            <PrivateRoute>
              <FeedbackPage />
            </PrivateRoute>
          }
        />
        <Route 
          path="/admin/payments" 
          element={
            <PrivateRoute>
              <PaymentsPage />
            </PrivateRoute>
          }
        />
        <Route 
          path="/admin/payouts" 
          element={
            <PrivateRoute>
              <PayoutsPage />
            </PrivateRoute>
          }
        />
        <Route 
          path="/admin/hwid" 
          element={
            <PrivateRoute>
              <HWIDPage />
            </PrivateRoute>
          }
        />
        <Route 
          path="/admin/camera" 
          element={
            <PrivateRoute>
              <CameraUsersPage />
            </PrivateRoute>
          }
        />
        <Route path="/amazon" element={<AmazonPage />} />
        <Route path="/ebay" element={<EbayPage />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/docs/how-it-works" element={<HowItWorks />} />
        <Route path="/docs/getting-started" element={<GettingStarted />} />
        <Route path="/docs/troubleshooting" element={<Troubleshooting />} />
        <Route path="/docs/install/windows" element={<InstallWindows />} />
        <Route path="/docs/install/macos" element={<InstallMacOS />} />
        <Route path="/docs/install/linux" element={<InstallLinux />} />
        <Route path="/docs/contact-support" element={<ContactSupport />} />
        <Route path="/docs/supported-websites" element={<SupportedWebsites />} />
        <Route path="/changelog" element={<Changelog />} />
        <Route path="/ref/:referrer/warmer" element={<ReferralWarmerPage />} />
        <Route path="/ref/:referrer/camera" element={<ReferralCameraPage />} />
        <Route path="/ref/:referrer" element={<ReferralPage />} />
        <Route path="/ref/:referrer/login" element={<ReferrerLoginPage />} />
        <Route path="/ref/:referrer/panel" element={<ReferrerPanelPage />} />
      </Routes>
    </Router>
  );
}

export default App;
